import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Loader2 } from "lucide-react";

// Shared motion card-flip feedback used during check-in / attendance scans.
// flip = null | { stage: "checking" } | { stage: "done", icon, title, sub, tone: "emerald"|"amber" }
export function CheckInFlipCard({ flip, onFinished }) {
  return createPortal(
    <AnimatePresence>
      {flip && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[95] grid place-items-center bg-slate-900/70 backdrop-blur-sm p-6"
          data-testid="checkin-flip-overlay"
        >
          <div style={{ perspective: 1400 }} className="w-full max-w-[280px]">
            <motion.div
              className="relative w-full aspect-[3/4] preserve-3d"
              animate={{ rotateY: flip.stage === "done" ? 180 : 0 }}
              transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
              onAnimationComplete={() => {
                if (flip.stage === "done") setTimeout(() => onFinished?.(), 1900);
              }}
            >
              <div
                className="absolute inset-0 rounded-[32px] backface-hidden bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 text-white grid place-items-center text-center p-8 shadow-2xl"
                data-testid="checkin-flip-front"
              >
                <Loader2 className="w-10 h-10 animate-spin text-amber-300" />
                <p className="mt-4 font-black text-lg tracking-tight">Sedang Check-In…</p>
                <p className="mt-1 text-xs text-white/50">Mohon tunggu sebentar</p>
              </div>
              <div
                className={`absolute inset-0 rounded-[32px] backface-hidden [transform:rotateY(180deg)] text-white grid place-items-center text-center p-8 shadow-2xl ${
                  flip.tone === "amber" ? "bg-gradient-to-br from-amber-500 to-orange-600" : "bg-gradient-to-br from-emerald-500 to-teal-600"
                }`}
                data-testid="checkin-flip-back"
              >
                {flip.icon && <flip.icon className="w-14 h-14" />}
                <p className="mt-4 font-black text-2xl tracking-tight">{flip.title}</p>
                {flip.sub && <p className="mt-1.5 text-sm text-white/85 font-semibold">{flip.sub}</p>}
              </div>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
